module.exports = __webpack_public_path__ + "2010908267ae1f2701e141a7bce0350a.svg";